<template>
  <transition name="nav-fade">
    <div
      v-if="issueActive && canSubmit"
      class="fixed bottom-4 right-4 z-toast max-w-xs"
      role="status"
    >
      <div
        class="flex items-start gap-3 rounded-xl border border-theme-border bg-theme-surface-raised p-3 shadow-theme-elevated"
      >
        <icon :path="mdiAlertCircleOutline" size="20" class="mt-0.5 shrink-0 text-theme-warning" />
        <div class="flex-1">
          <p class="text-sm font-semibold text-theme-text">{{ t('feedback.prompt_title') }}</p>
          <p class="mt-0.5 text-xs text-theme-text-secondary">{{ t('feedback.prompt_body') }}</p>
          <div class="mt-2 flex gap-2">
            <app-button size="xs" tone="primary" :label="t('feedback.prompt_action')" @click="reportIssue" />
            <app-button size="xs" variant="ghost" tone="muted" :label="t('feedback.prompt_dismiss')" @click="dismissIssue" />
          </div>
        </div>
        <button
          type="button"
          class="shrink-0 text-theme-text-secondary hover:text-theme-text"
          :aria-label="t('feedback.prompt_dismiss')"
          @click="dismissIssue"
        >
          <icon :path="mdiClose" size="16" />
        </button>
      </div>
    </div>
  </transition>
</template>

<script setup>
  import { useI18n } from 'vue-i18n';
  import { mdiAlertCircleOutline, mdiClose } from '@mdi/js';

  import AppButton from '@/components/ui/buttons/AppButton.vue';
  import Icon from '@/components/Icon';
  import { useFeedback, openFeedback, dismissIssue } from '@/composables/useFeedback';
  import { useFeedbackAccess } from '@/features/feedback/composables/useFeedbackAccess';

  const { t } = useI18n();
  const { issueActive, issueContext } = useFeedback();
  // Same allowlist as the floating button and the profile-menu entry: a nudge
  // that opens a reporter the account may not use is worse than no nudge.
  const { canSubmit } = useFeedbackAccess();

  function reportIssue() {
    openFeedback(issueContext.value);
  }
</script>
